@if (!report) {
  <div>
    @if (scatterChartData.length > 0) {
      <div class="d-flex h-100 chart-container">
        <div class="d-block flex-grow-1 p-2 chart-wrapper">
          <highcharts-chart
            class="w-100 d-block"
            [Highcharts]="highcharts"
            [options]="chartOptions"
            [(update)]="updateFlag"
            [callbackFunction]="chartCallback">
          </highcharts-chart>
        </div>
      </div>
    }
  </div>
}



@if (report) {
  <div>
    @if (scatterChartData.length > 0) {
      <div class="h-100">
        <div class="row w-100">
          <div class="overflow-auto report-legend-scroll">
            <ul class="nav">
              @for (legendItem of legendData; track $index; let i = $index) {
                <li class="d-inline mx-1"
                  (click)="updateDataset(legendItem.datasetIndex)">
                  <app-color-line-legend [color]="legendItem.fillStyle" [disabled]="legendItem.hidden"
                    [doNotTranslate]="true" [text]="legendItem.text"
                    [type]="legendItem.pointStyle === 'scatter' ? 'circle' : (legendItem.pointStyle === 'dash' ? 'dashed' : 'line')"
                    [reportView]="true">
                  </app-color-line-legend>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    }
    <div class="row w-100">
      <highcharts-chart
        class="w-100 d-block"
        [Highcharts]="highcharts"
        [options]="chartOptions"
        [(update)]="updateFlag"
        [callbackFunction]="chartCallback">
      </highcharts-chart>
    </div>
  </div>
}
